import AutoSubmit from '../components/AutoSubmit'
import BulkAction from '../components/BulkAction'
import TriggerFileUpload from '../components/TriggerFileUpload'

export default class PublicationJobsAddressLists {
  constructor(params) {
    this.params = params;
    this.toasting = false;
  }

  index() {
    new AutoSubmit();
    let ba = new BulkAction({
      target: "#addresses-bulk-store",
      action: "#addresses-bulk-action",
      secondary_nav: "#addresses-action-bar",
      checked_scope: "td",
    })

    new N2Styles.searchBar({
      safeContainer: '.js-table-search',
      showSelector: '.show-table-search',
      visible: this.params['search'],
    });

    this.bindDisabledToasts()
  }

  new() {
    new TriggerFileUpload();
    if (this.params.failed) {
      $('.js-address-upload-failed-modal').modal()
      $('.modal-backdrop').addClass('in')
    }
  }

  // For disabled controls on the address list, show a toast explaining why
  // they can't be used and make sure it doesn't spam the screen if they try to
  // click multiple times / multiple elements.
  bindDisabledToasts() {
    N2.handle("click", ".disabled, [disabled]", (evt) => {
      if (this.toasting) { return; }
      this.toasting = true;
      new N2Styles.toast("That action is only available when this job is in Waiting status.")
      setTimeout(() => {
        this.toasting = false;
      }, 5000);
    });
  }
}
